import { render, staticRenderFns } from "./ProductEditLabels.vue?vue&type=template&id=5b16b87d"
import script from "./ProductEditLabels.vue?vue&type=script&lang=ts"
export * from "./ProductEditLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b16b87d')) {
      api.createRecord('5b16b87d', component.options)
    } else {
      api.reload('5b16b87d', component.options)
    }
    module.hot.accept("./ProductEditLabels.vue?vue&type=template&id=5b16b87d", function () {
      api.rerender('5b16b87d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditLabels.vue"
export default component.exports